import useCheckIsDevice from "@/hooks/useDeviceType";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

const ProjectTitle = ({ project }) => {
  const isMobile = useCheckIsDevice("mobile");
  const [showDesc, setShowDesc] = useState(false);

  const { t } = useTranslation("submit", {
    keyPrefix: "project",
  });

  return (
    <div className="left-0 top-0 z-10 flex h-full flex-col justify-end px-[17px] pb-[20px] md:static md:w-3/4">
      <h1 className="mb-0 line-clamp-2 text-[24px] font-bold leading-8  text-muted-foreground">
        {t("Projet")} : {project.name}
      </h1>
      {project.description && project.description !== "" && (
        <>
          <p
            className={`${
              !showDesc ? "line-clamp-3" : ""
            } overflow-hidden text-[14px] text-[#595959]`}
            dangerouslySetInnerHTML={{
              __html: project.description?.replace(/\n/g, "<br />"),
            }}
          />
          <div>
            <a
              href=""
              className="inline underline"
              onClick={(e) => {
                e.preventDefault();
                setShowDesc(!showDesc);
              }}
            >
              {showDesc ? t("Voir moins") : t("Voir plus")}
            </a>
          </div>
        </>
      )}
      {project?.status && project?.status === 3 && (
        <div className="mt-4 flex items-start gap-2.5 bg-amber-50 border-l-4 border-amber-500 p-3 rounded-md animate-fadeIn w-full">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-amber-800 text-sm leading-snug">
            <span className="font-medium">Attention :</span> toute
            modification apportée entraînera une nouvelle soumission du projet
            pour validation.
          </p>
        </div>
      )}
    </div>
  );
};

export default ProjectTitle;
